import React from "react";
import { Typography, Link, Box } from "@mui/material";

function Copyright() {
  return (
    <Box align="center">
      <Typography variant="body1" color="text.secondary">
        {"Copyright © "}
        <Link color="inherit" href="http://www.viocare.com/" target="_blank" rel="noopener noreferrer">
          Viocare, Inc.
        </Link>{" "}
        {new Date().getFullYear()}
        {"."}
        {" | "}
        {"Version: " + process.env.REACT_APP_VERSION + " (" + process.env.REACT_APP_BUILD+")"}
        {" | "}
        {process.env.REACT_APP_ENVIRONMENT}
      </Typography>
    </Box>
  );
}

export default Copyright;
